export function slider() {
  //.mainSlide
  const mainSlide = document.querySelector('.mainSlide');
  if(mainSlide) {
    document.addEventListener('DOMContentLoaded', () => {
      const swiper = new Swiper(mainSlide, {
        slidesPerView: 1,
        loop: true,
        speed: 3000,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        breakpoints: {
          768: {

          }
        }
      });
    });
  }


  


  //loop slide
  const policy_slide = document.querySelector('.p-indexPolicy_slide');
  if(policy_slide) {
    document.addEventListener('DOMContentLoaded', () => {
      const swiper = new Swiper(policy_slide, {
        loop: true,
        slidesPerView: "auto",
        speed: 12000,
        spaceBetween: 20,
        allowTouchMove: false,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
            //reverseDirection: true, // 逆回転にするオプション
        },
        breakpoints: {
          768: {
            spaceBetween: 40,
          }
        }
      });
    });
  }

    //loop slide
  const policy_slide_reverse = document.querySelector('.p-indexPolicy_slide._reverse');
  if(policy_slide_reverse) {
    document.addEventListener('DOMContentLoaded', () => {
      const swiper = new Swiper(policy_slide_reverse, {
        loop: true,
        slidesPerView: "auto",
        speed: 12000,
        spaceBetween: 20,
        allowTouchMove: false,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
            reverseDirection: true, // 逆回転にするオプション
        },
        breakpoints: {
          768: {
            spaceBetween: 40,
          }
        }
      });
    });
  }

  //loop slide
  const service_slide = document.querySelector('.p-serviceSec_item_slide');
  if(service_slide) {
    document.addEventListener('DOMContentLoaded', () => {
      const swiper = new Swiper(service_slide, {
        loop: true,
        slidesPerView: "auto",
        speed: 12000,
        allowTouchMove: false,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
            //reverseDirection: true, // 逆回転にするオプション
        },
        // breakpoints: {
        //   768: {
        //   }
        // }
      });
    });
  }

  const recruitInsta_slide = document.querySelector('.p-recruitInsta_slide');
  if(recruitInsta_slide) {
    document.addEventListener('DOMContentLoaded', () => {
      const swiper = new Swiper(recruitInsta_slide, {
        loop: true,
        slidesPerView: "auto",
        speed: 12000,
        spaceBetween: 10,
        allowTouchMove: false,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
            //reverseDirection: true, // 逆回転にするオプション
        },
        breakpoints: {
          768: {
            spaceBetween: 20,
          }
        }
      });
    });
  }
  

}